import React, {Suspense} from 'react';
import {Box, Grid, Link, styled, Typography} from '@mui/material';
import routes from '../../routes';
import {ReactComponent as RexplorerLogo} from '../../assets/logo_rexplorer.svg';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import {useTranslation} from 'react-i18next';

const LogoRow = styled(Grid)(({ theme }) => ({
    ...theme.typography.body2,
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    padding: '10px',
    height: '10vh',
}));

export const LogoHeader = () => {
    const { t } = useTranslation();

    return (
        <LogoRow>
            <Grid container display="flex" alignItems="center">
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'flex-start'}}>
                    <Link href={routes.LOGIN}>
                        <RexplorerLogo/>
                    </Link>
                </Grid>
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <Typography
                        variant="body1"
                        color="textSecondary"
                        display="flex"
                        alignItems="center"
                        style={{fontSize: '16px', fontWeight: '600', marginRight: '2vw'}}
                    >
                        <Link
                            href={routes.LOGIN}
                            underline="hover"
                            color="inherit"
                        >
                            <b>{t('log_in')}</b>
                        </Link>
                    </Typography>
                    <Box width="fit-content">
                        <Suspense fallback={''}>
                            <LanguageSelector />
                        </Suspense>
                    </Box>
                </Grid>
            </Grid>
        </LogoRow>
    );
};
